module.exports = __webpack_public_path__ + "static/media/mainbox-empty.6c0e7066.svg";